'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var green={1:'#edf7ed',2:'#d1ead1',3:'#a3d4a3',4:'#79c679',5:'#35a335',6:'#048a04',7:'#047103',8:'#015e02',9:'#024d03',10:'#023302',inflection:6};exports.default=(0,_createColorPalette2.default)(green,'green');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/green.js
 **/